import {observer} from "mobx-react";
import React from "react";
import {FormProps, lovValue} from "../../core/form/formUtils";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import ProjectVersionDoor from "../domain/project/projectVersionDoorDomain";
import {BlockComp} from "../../core/components/blockComp/blockComp";
import StyledSelect from "../../core/components/fields/styledSelect";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {StatusActiveComp, StatusActiveComp__h5_style} from "../../core/components/buttons/statusActiveComp";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PROJECT_MATERIAL_ENTITY, PROJECT_VERSION_ROOM_ENTITY} from "../entityConstants";
import {ProjectVersion} from "../domain/project/projectVersionDomain";

@observer
class ProjectVersionDoorForm extends React.Component<FormProps<ProjectVersionDoor, ProjectVersion>, any> {


  render(): JSX.Element | false | null {
    let {dataObject, rootObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionDoorFormDefinition.formName);
    let {name, roomTo, roomFrom, doorType, height, width, reachableOnlyByLadder, threshold, remoteControl,
      entranceAtLeast1250mmWide, suitableForHandicapped, protectedAgainstWheelchair,
      lockNotMoreThen1000mmAbove, handleNotMoreThen1000mmAbove, markedContrastingly,
      frameMaterial, frameMaterialMass, leafMaterial1, leafMaterial1Mass,
      leafMaterial2, leafMaterial2Mass, leafMaterial3, leafMaterial3Mass} = fields;

    let openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-6">
            <MdTextField {...name.props} />
            <Validate field={name} value={name.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...roomFrom.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, PROJECT_VERSION_ROOM_ENTITY, {projectVersionId : rootObject.versionId})} clearable={true} />
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...roomTo.props} async={true} asterixForAll loadOptions={optionsSearch.bind(this, PROJECT_VERSION_ROOM_ENTITY, {projectVersionId : rootObject.versionId})} clearable={true} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <StyledSelect {...doorType.props} />
            <Validate field={doorType} value={doorType.props.value}/>
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdTextField {...height.props} />
            <Validate field={height} value={height.props.value}/>
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdTextField {...width.props} />
            <Validate field={width} value={width.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...frameMaterial.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})} />
            <Validate field={frameMaterial} value={frameMaterial.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...frameMaterialMass.props} />
            <Validate field={frameMaterialMass} value={frameMaterialMass.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...leafMaterial1.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})}/>
            <Validate field={leafMaterial1} value={leafMaterial1.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...leafMaterial1Mass.props} />
            <Validate field={leafMaterial1Mass} value={leafMaterial1Mass.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...leafMaterial2.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...leafMaterial2Mass.props} />
            <Validate field={leafMaterial2Mass} value={leafMaterial2Mass.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...leafMaterial3.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...leafMaterial3Mass.props} />
            <Validate field={leafMaterial3Mass} value={leafMaterial3Mass.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...reachableOnlyByLadder.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...threshold.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...remoteControl.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...entranceAtLeast1250mmWide.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...suitableForHandicapped.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...protectedAgainstWheelchair.props} />
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...lockNotMoreThen1000mmAbove.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...handleNotMoreThen1000mmAbove.props} />
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdCheckbox {...markedContrastingly.props} />
          </div>
        </div>
      </div>
    );

    return (
      <BlockComp noPadding>
        {openContent}
      </BlockComp>
    );
  }
}



const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersionDoor>) => (
  <div style={{width: '100%'}}>

    <div style={{display: 'flex'}}>
      { disabled ? null :  <StatusActiveComp activeObject={dataObject} entity={entity} id={dataObject.doorId} />}
      <h5 style={StatusActiveComp__h5_style}> {dataObject.name} </h5>
    </div>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.name.textLabel} value={dataObject.name}/>
      <ClosedFormField label={fields.roomFrom.textLabel} value={dataObject.roomFrom}/>
      <ClosedFormField label={fields.roomTo.textLabel} value={dataObject.roomTo}/>
      <ClosedFormField label={fields.doorType.textLabel} value={dataObject.doorType}/>
      <ClosedFormField label={fields.height.textLabel} value={dataObject.height}/>
      <ClosedFormField label={fields.width.textLabel} value={dataObject.width}/>
      <ClosedFormField label={fields.reachableOnlyByLadder.textLabel} value={dataObject.reachableOnlyByLadder}/>
      <ClosedFormField label={fields.threshold.textLabel} value={dataObject.threshold}/>
      <ClosedFormField label={fields.remoteControl.textLabel} value={dataObject.remoteControl}/>
      <ClosedFormField label={fields.entranceAtLeast1250mmWide.textLabel} value={dataObject.entranceAtLeast1250mmWide}/>
      <ClosedFormField label={fields.suitableForHandicapped.textLabel} value={dataObject.suitableForHandicapped}/>
      <ClosedFormField label={fields.protectedAgainstWheelchair.textLabel} value={dataObject.protectedAgainstWheelchair}/>
      <ClosedFormField label={fields.lockNotMoreThen1000mmAbove.textLabel} value={dataObject.lockNotMoreThen1000mmAbove}/>
      <ClosedFormField label={fields.handleNotMoreThen1000mmAbove.textLabel} value={dataObject.handleNotMoreThen1000mmAbove}/>
      <ClosedFormField label={fields.markedContrastingly.textLabel} value={dataObject.markedContrastingly}/>
    </ClosedFormBlock>

  </div>
);


export const ProjectVersionDoorFormDefinition: DefinitionType = {
  formName: 'ProjectVersionDoorForm',
  fields: [
    {name : 'name', validators : ['IsRequired']},
    {name : 'roomFrom'},
    {name : 'roomTo'},
    {name : 'doorType', validators : ['IsRequired']},
    {name : 'height', validators : ['IsRequired']},
    {name : 'width', validators : ['IsRequired']},
    {name : 'frameMaterial', validators: ['IsRequired']},
    {name : 'frameMaterialMass', validators: ['IsRequired', 'IsNumber']},
    {name : 'leafMaterial1', validators: ['IsRequired']},
    {name : 'leafMaterial1Mass', validators: ['IsRequired', 'IsNumber']},
    {name : 'leafMaterial2'},
    {name : 'leafMaterial2Mass', validators: ['IsNumber']},
    {name : 'leafMaterial3'},
    {name : 'leafMaterial3Mass', validators: ['IsNumber']},
    {name: 'reachableOnlyByLadder'},
    {name: 'threshold'},
    {name: 'remoteControl'},
    {name: 'entranceAtLeast1250mmWide'},
    {name: 'suitableForHandicapped'},
    {name: 'protectedAgainstWheelchair'},
    {name: 'lockNotMoreThen1000mmAbove'},
    {name: 'handleNotMoreThen1000mmAbove'},
    {name: 'markedContrastingly'},
  ]
};

export default createForm(ProjectVersionDoorFormDefinition, ClosedContent)(ProjectVersionDoorForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionDoorForm.tsx